import {geoConstants} from "./geo.constants";
import {authenticationConstants} from "../authentication/auth.constants";

const initialState = {
    villes: null,
    loading: false,
    error: null,
};

export function geo(state = initialState, action) {
    switch (action.type) {
        case geoConstants.VILLES_FETCH_REQUEST:
            return { ...state, loading: true, error: null };
        case geoConstants.VILLES_FETCH_SUCCESS:
            return { ...state, loading: false, villes: action.villes, error: null };
        case geoConstants.VILLES_FETCH_FAILURE:
            return { ...state, loading: false, error: action.error };
        case geoConstants.CLEAR:
            return { ...initialState };
        case authenticationConstants.LOGOUT:
            return { ...initialState };
        default:
            return state;
    }
}
